// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__184oI","textarea":"styles_textarea__2Xmdy"};